// Tile tab content — biome info, resource, coordinates.
import type { SceneNode } from '@aod/protocol';
import { Badge } from '@aod/ui/components/ui/badge';
import { Separator } from '@aod/ui/components/ui/separator';
import { useT } from '../../i18n/index.js';
import { Row } from './InfoPanelShell.js';
import { biomeLabel, biomeMeta } from './biome.js';

export function TileTabContent({ tile }: { tile: SceneNode }) {
  const t = useT();
  const biome = (tile.props?.biome as string | undefined) ?? 'unknown';
  const meta = biomeMeta(biome);
  const q = tile.props?.q as number | undefined;
  const r = tile.props?.r as number | undefined;
  const variant = tile.props?.variant as number | undefined;
  const resource = tile.props?.resource as string | undefined;
  const color = tile.visual?.material?.color ?? '#7ea84a';

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-3">
        <div
          className="flex size-12 items-center justify-center rounded-md"
          style={{
            background: `color-mix(in oklch, ${color} 24%, transparent)`,
            color,
          }}
          aria-hidden
        >
          <meta.Icon className="size-6" />
        </div>
        <div className="flex flex-1 flex-col gap-1">
          <Badge variant={meta.traversable ? 'secondary' : 'destructive'}>
            {meta.traversable ? t('tile.traversable') : t('tile.impassable')}
          </Badge>
          <p className="text-[11px] leading-snug text-muted-foreground">
            {meta.traversable ? t('tile.traversableHint') : t('tile.impassableHint')}
          </p>
        </div>
      </div>

      <Separator />

      <div className="flex flex-col gap-1.5">
        <Row label={t('tile.biome')}>{biomeLabel(t, biome)}</Row>
        {resource && <Row label={t('tile.resource')}>{resource}</Row>}
        <Row label={t('tile.axial')}>
          ({q ?? '?'}, {r ?? '?'})
        </Row>
        {variant !== undefined && <Row label={t('tile.variant')}>{variant}</Row>}
      </div>
    </div>
  );
}
